import React, { forwardRef, useState } from "react";
import classnames from "classnames";
import styled from 'styled-components';
import CtaButton from "./components/CtaButton";
import IBuildrProps from '../../utilities/IBuildrProps';
import { useSwipeable } from 'react-swipeable';

interface IRatesCategoryProps extends IBuildrProps {
    tabId: number,
    selected: boolean;
    categoryTitle: string;
    children: any;
    setActiveTab: any;
    categoriesLength: number;
    ctaText: string;
    ctaHyperLink: string
}

const NEXT = 'NEXT';
const PREV = 'PREV';

const CarouselContainer = styled.div<{ $pos: number, $numItems: number }>`
    flex-flow: row;
    gap: 15px;
    transition: transform .5s ease;
    transform: ${(props) => {
        if (props.$pos > 0) {
            const lastItem = (props.$pos === props.$numItems - 1);
            return `translateX(calc((${props.$pos} * (-90% - 15px)) + ${lastItem ? '10%' : '5%'}))`;
        }

        return `translateX(0)`; 
    }};
    @media(min-width: 992px){
        flex-flow: wrap;
        transition: none;
        transform: translateX(0);
    }
`;

export default styled(forwardRef((props: IRatesCategoryProps, ref: any) => {
    const { cmsId, editorClassObj, className, categoryTitle, children, setActiveTab, tabId, selected, categoriesLength = 0, ctaText, ctaHyperLink } = props;

    const [pos, setPos] = useState(0);
    const numItems = React.Children.count(children);

    const slide = (direction) => {
        const newPos = direction === NEXT ? pos + 1 : pos - 1;
        if (newPos >= 0 && newPos < children.length) {
            setPos(newPos);
        }
    };

    const handlers = useSwipeable({
        onSwipedLeft: () => slide(NEXT),
        onSwipedRight: () => slide(PREV),
        swipeDuration: 500,
        preventScrollOnSwipe: true
      });

    return (
        <>
            {categoriesLength > 1 ?
                <> 
                    <div ref={ref} data-id={cmsId} className={classnames('category-tab d-none d-lg-inline', className, editorClassObj, {selected})}>
                        <p onClick={() => setActiveTab(tabId)} className={classnames({'category-title pr-0': tabId === categoriesLength - 1})}>
                            <span className="d-block position-relative">{categoryTitle}</span>
                        </p>
                    </div>
                    {tabId === categoriesLength - 1 ?
                        <CtaButton 
                            ctaText={ctaText}
                            ctaHyperLink={ctaHyperLink}
                            customClass={classnames(className, "d-none d-lg-inline-flex")}
                        />
                    : null
                    }
                </>
            : null}
            <div ref={ref} data-id={cmsId} className={classnames('category-tab-content w-100', className,  editorClassObj, { selected })} {...handlers}>
                <CarouselContainer $pos={pos} $numItems={numItems} className='carousel-container d-flex'>
                    {React.Children.map(children,(card, index) => {
                        return React.cloneElement(card, {
                            width: `${(100 / children.length)}%`,
                        });
                    })}
                </CarouselContainer>
            </div>
        </>

    );
}))`

&.btn {
    order:1;
    margin-left: auto;
}
&.category-tab {
    order: 1;

    cursor: pointer;

    p {
        font-family: "National2", sans serif;
        font-weight: 500;
        margin: 0;
        font-size: 1rem;
        border-bottom: 1px solid #E2E2E2;
        padding-right: 2rem;
        span {
            padding-bottom: 8px;
            &::after {
                content: '';
                display: none;
                width: 100%;
                height: 3px;
                bottom: -2px;
                position: absolute;
                border-radius: 0.2rem;
            }
        }
    }

    &:hover {
        p {
            color: var(--pebble);
        }
        span {
            &::after {
                display: block;
                background: var(--pebble);
            }
        }
    }

    &.selected {
        p {
            color: black;
        }
        span {
            &::after {
                display: block;
                background: #CE202E;
            }
        }
    }
}

&.category-tab-content {
    order: 2;
    display: block;
    margin-top: 3.5rem;
    padding: 1px;
    
    @media(max-width: 992px){
        margin-top: 1rem;
    }
}

&.category-tab-content:not(.selected) {
    display: none;
}`;
